// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__1eaS-","advisors":"advisors__1yvLb","sliderBox":"sliderBox__aXGqH","slider":"slider__1MguT","sliderContent":"sliderContent___oLaI","advisorImg":"advisorImg__2EX-E","buttons":"buttons__14DtC","button":"button__3tn9v","bottom":"bottom__3clVr","name":"name__38OZZ","nameExiting":"nameExiting__3_TO9","company":"company__1bTJO","reversed":"reversed__1wUnC","martina":"martina__1cwgX","kate":"kate__m1J6G","tom":"tom__32Zmg"};


//////////////////
// WEBPACK FOOTER
// ./components/advisors/style.styl
// module id = /MDC
// module chunks = 0